var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoKnowYourCustomer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_know_your_customer",
    d: "M230.144,726.684a17.291,17.291,0,0,1-3.441.294h-.136c-6.25-.031-6.686-2.056-6.6-2.886a6.161,6.161,0,0,1,3.721-5.326.616.616,0,0,1,.2-.029,1,1,0,0,1,.608.217,3.259,3.259,0,0,0,3.325.535,4.805,4.805,0,0,0,1.051,6.481A4.914,4.914,0,0,0,230.144,726.684Zm-3.563-8.592a3.539,3.539,0,1,0-3.38-3.535A3.461,3.461,0,0,0,226.581,718.092Zm7.95,7.035a3.96,3.96,0,0,1-2.126.895,4.245,4.245,0,0,1-.437.023h-.006a3.988,3.988,0,0,1-2.475-.862,3.851,3.851,0,0,1-.609-5.486,3.965,3.965,0,0,1,2.664-1.437,4.107,4.107,0,0,1,.442-.024,3.988,3.988,0,0,1,2.476.862,3.854,3.854,0,0,1,1.031,4.857.829.829,0,0,1,.089.046l2.094,1.652.009.007a.762.762,0,0,1,.106,1.071.784.784,0,0,1-.609.291h0a.791.791,0,0,1-.487-.169l-2.1-1.653-.012-.01A.8.8,0,0,1,234.531,725.127Zm-.256-3.233a2.253,2.253,0,0,0-.855-1.53,2.331,2.331,0,0,0-1.447-.5h0c-.085,0-.17.005-.255.014a2.315,2.315,0,0,0-1.556.84,2.231,2.231,0,0,0-.5,1.674,2.257,2.257,0,0,0,.854,1.53h0a2.327,2.327,0,0,0,1.446.5,2.372,2.372,0,0,0,.252-.014h.008A2.293,2.293,0,0,0,234.275,721.894Z",
    transform: "translate(-219.962 -711.022)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoKnowYourCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_know_your_customer.8ed47ed5150c105afdc11dd149155f0e.svg";